import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { api } from '@/lib/api';
import { toast } from 'sonner';

export const PromoAdjustDialog = ({ promo, onClose, onSaved }) => {
    const [date, setDate] = useState('');
    const [file, setFile] = useState(null);
    const [busy, setBusy] = useState(false);
    useEffect(() => { if (promo) { setDate(promo.start_date || ''); setFile(null); } }, [promo]);
    const save = async () => {
        const fd = new FormData();
        fd.append('start_date', date || '');
        if (file) fd.append('image', file);
        setBusy(true);
        try {
            await api.post(`/promotions/admin/${promo.id}/adjust`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            toast.success('Promotion updated'); onSaved();
        } catch (e) { toast.error(e.response?.data?.detail || 'Update failed'); }
        finally { setBusy(false); }
    };
    return (
        <Dialog open={!!promo} onOpenChange={(o) => !o && onClose()}>
            <DialogContent data-testid="promo-adjust-dialog">
                <DialogHeader><DialogTitle>Adjust banner & date</DialogTitle>
                    <DialogDescription>Change the live start date ({promo?.days} days) or replace the banner image before approving.</DialogDescription></DialogHeader>
                <div className="space-y-1.5"><Label className="text-xs">Live from (IST)</Label><Input type="date" value={date} onChange={e => setDate(e.target.value)} data-testid="promo-adjust-date" /></div>
                <div className="space-y-1.5"><Label className="text-xs">Replace banner image (optional)</Label><Input type="file" accept="image/jpeg,image/png,image/webp" onChange={e => setFile(e.target.files?.[0] || null)} data-testid="promo-adjust-image" /></div>
                <DialogFooter><Button variant="outline" onClick={onClose}>Cancel</Button>
                    <Button onClick={save} disabled={busy} className="bg-[#0E2A47] hover:bg-[#0B223A]" data-testid="promo-adjust-save">{busy ? 'Saving…' : 'Save'}</Button></DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
